import script from "./PwaPayroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaPayroll.vue?vue&type=script&setup=true&lang=ts"

import "./PwaPayroll.vue?vue&type=style&index=0&id=757cc8a9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757cc8a9"]])

export default __exports__